import {
  ContactPage,
  DonatePage,
  ErrorPage,
  GalleryPage,
  GuidelinesPage,
  HistoryPage,
  HomePage,
  PbhAboutPage,
  PbhSearchPage,
  PurposePage,
  RegisterPage,
  StorePage,
  TrusteesPage,
} from "../pages";
import React from "react";
import { Route, Routes } from "react-router-dom";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="register" element={<RegisterPage />} />
      <Route path="about">
        <Route path="purpose" element={<PurposePage />} />
        <Route path="trustees" element={<TrusteesPage />} />
        <Route path="guidelines" element={<GuidelinesPage />} />
      </Route>
      <Route path="history" element={<HistoryPage />} />
      <Route path="store" element={<StorePage />} />
      <Route path="gallery" element={<GalleryPage />} />
      <Route path="pbh">
        <Route path="about" element={<PbhAboutPage />} />
        <Route path="search" element={<PbhSearchPage />} />
      </Route>
      <Route path="donate" element={<DonatePage />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default AppRoutes;
